var map = {
	"./EPC.svg": 97729,
	"./arrowRight.svg": 20901,
	"./cargo.svg": 71197,
	"./contacts.svg": 20408,
	"./contracts.svg": 63090,
	"./dashboard.svg": 74506,
	"./drivers.svg": 69132,
	"./leftArrow.svg": 86126,
	"./location.svg": 11102,
	"./operations.svg": 88343,
	"./order.svg": 73521,
	"./orders.svg": 35430,
	"./organization.svg": 32729,
	"./partners.svg": 34591,
	"./reports.svg": 38322,
	"./routes.svg": 12645,
	"./routesZone.svg": 41308,
	"./trips.svg": 73577,
	"./users.svg": 66932,
	"./vehicalMonitoring.svg": 53474,
	"./vehicleDictionary.svg": 50617,
	"./vehicleSchedules.svg": 7239,
	"./vehicles.svg": 45560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91223;